export default [
    {
        path: '/temperatura/dashboard',
        name: 'temperatura-produccion-dashboard',
        component: () => import('@/views/pages/temperatura/Dashboard.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Dashboard',
            action: 'ver-temperatura-produccion-dashboard',
            breadcrumb: [
                {
                    text: 'Temperatura',
                    active: true,
                },
            ],
        },
    },
    {
        path: '/temperatura/dashboard_mantenimeinto',
        name: 'temperatura-produccion-dashboard-mantenimiento',
        component: () => import('@/views/pages/temperatura/DashboardMantenimiento.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Dashboard',
            action: 'ver-temperatura-produccion-dashboard-mantenimiento',
            breadcrumb: [
                {
                    text: 'Temperatura',
                    active: true,
                },
            ],
        },
    },

    {
        path: '/temperatura/informes',
        name: 'temperatura-produccion-informes',
        component: () => import('@/views/pages/temperatura/informes.vue'),
        meta: {
            title: 'i18n:',
            pageTitle: 'Informes',
            action: 'ver-temperatura-produccion-informes',
            breadcrumb: [
                {
                    text: 'Temperatura',
                    active: true,
                },
            ],
        },
    },
]
